// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__c0zUz","sidebar":"Sidebar_sidebar__auItK","item":"Sidebar_item__mkAa2","icon":"Sidebar_icon__2Or5K","label":"Sidebar_label__7XYe+"};